<template>
  <div class="site-page-header" role="banner">
    <div class="header-inner">
      <router-link class="brand-link" to="/" :aria-label="displayTitle">
        <img class="brand-logo" src="/logo.png" :alt="displayTitle" />
        <span class="sr-only">{{ displayTitle }}</span>
      </router-link>
      <SiteNav></SiteNav>
    </div>
  </div>
</template>

<script>
import SiteNav from "./SiteNav.vue";

export default {
  name: "SiteHeader",
  components: { SiteNav },
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    displayTitle() {
      const t = (this.title || "").trim();
      return t || "Castor Oil";
    },
  },
};
</script>

<style scoped>
.site-page-header {
  background: linear-gradient(
    90deg,
    #daa93d 0%,
    #f7d478 55%,
    #fade86 100%
  );
  border-bottom: 0;
  height: auto !important;
  /* Keep header height stable even if logo size changes */
  min-height: 72px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
}

.header-inner {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 24px;
  flex-wrap: nowrap;
}

.brand-link {
  text-decoration: none;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
}

.brand-logo {
  display: block;
  height: 34px;
  width: 114px;
  max-width: 114px;
  margin-right: 10px;
  object-fit: cover;
  object-position: center;
  image-rendering: -webkit-optimize-contrast;
  transform: translateZ(0);
}

.brand-link:hover .brand-logo {
  filter: none;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

@media (max-width: 640px) {
  .site-page-header {
    min-height: 64px;
    padding: 8px 12px;
  }

  .header-inner {
    flex-direction: column;
    align-items: stretch;
    flex-wrap: wrap;
    gap: 10px;
  }

  .brand-link {
    justify-content: center;
    flex: 0 0 auto;
  }

  .brand-logo {
    margin-right: 0;
  }

  .site-nav {
    justify-content: flex-start;
  }
}
</style>
